import { useState } from "react";
// css
import "./contact.css";
// other assets
import contactBG from "assets/Images/bg/contactBG.png";
import CustomInput from "Utills/CustomInput/CustomInput";
import { useNotifyContext } from "context/notifyContext";
import locationIcon from "assets/Images/icons/Location.png";
import mailIcon from "assets/Images/icons/mail.png";
import axios from "axios";
import { Slide } from "react-reveal";
import { Helmet } from "react-helmet";
//

// api endpoints
let api_contact = process.env.REACT_APP_API_CONTACT;

//============================= THIS IS A CONTACT PAGE ===================================
const Contact = () => {
  //===================== notification contaxt ===============
  const { set_notify, loader, set_loader } = useNotifyContext();
  // form data states
  const [data, setData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    subject: "",
    message: "",
    terms: false,
  });
  // error state for validating all the form fields
  const [errors, setErrors] = useState({
    first_name: { invalid: false, msg: "" },
    last_name: { invalid: false, msg: "" },
    email: { invalid: false, msg: "" },
    subject: { invalid: false, msg: "" },
    message: { invalid: false, msg: "" },
  });

  //================== This Function is for Handle inputs fields onchange  ======================
  const handlePersonalForm = (e) => {
    const { name, value, checked } = e.target;
    if (name === "message" && value.length > 500) {
      set_notify({ open: true, type: "error", msg: "Length Exceeded" });
    } else {
      setData({
        ...data,
        [name]: name === "terms" ? checked : value,
      });
      if (value?.trim()?.length > 0) {
        setErrors({
          ...errors,
          [name]: { invalid: false, msg: "" },
        });
      } else {
        setErrors({
          ...errors,
          [name]: { invalid: true, msg: "required" },
        });
      }
    }
  };

  // all the field names which we want to validate
  let fieldsToCheck = [
    "first_name",
    "last_name",
    "email",
    "subject",
    "message",
  ];
  // validator
  const validGets = (fields) => {
    return fields?.filter((field) => errors[field]?.invalid === true);
  };

  // ========== SUBMIT CONTACT FORM  THIS IS STATIC FOR NOW============= ===
  const sendContactForm = (e) => {
    e.preventDefault();
    if (data.message.length <= 500 && validGets(fieldsToCheck).length === 0) {
      if (data.terms === true) {
        set_loader(true);
        let dataObj = {
          name: data?.first_name,
          surname: data?.last_name,
          email: data?.email,
          subject: data?.subject,
          message: data?.message,
        };
        axios({
          method: "POST",
          url: api_contact,
          data: dataObj,
          headers: { "Content-Type": "application/json; charset=utf-8" },
        })
          .then((response) => {
            let data = response?.data;
            if (data.status !== "error") {
              setData({
                first_name: "",
                last_name: "",
                email: "",
                subject: "",
                message: "",
                terms: false,
              });
              set_notify({
                open: true,
                type: "success",
                msg: "your query is submitted. Thanks for contact.",
              });
              set_loader(false);
            } else {
              set_loader(false);
              set_notify({
                open: true,
                msg: data?.["error-message"],
                type: "error",
              });
              console.log("Error  ====>", data);
            }
          })
          .catch((err) => {
            console.log("Error ====>", err.message);
            set_notify({ open: true, type: "error", msg: err.message });
            set_loader(false);
          });
      } else {
        set_notify({
          open: true,
          type: "error",
          msg: "Please accept terms &  conditions.",
        });
      }
    } else {
      set_notify({
        open: true,
        type: "error",
        msg: "Please fill the form correctly all the fields are necessary.",
      });
    }
  };

  //
  return (
    <>
      <Helmet>
        <title>Cyan | Contact us</title>
      </Helmet>
      <div
        className="contact-page-top"
        style={{ backgroundImage: `url(${contactBG})` }}
      >
        <div className="cs_container">
          <Slide bottom>
            <h1>Contact Us</h1>
          </Slide>
        </div>
      </div>
      <div className="cs_container overflow-hidden my-4">
        <Slide left cascade>
          <div className="ct_form_top_sec overflow-hidden">
            <h2 className="text-pr ct-form-sec-head">
              Send us a message and we will respond as soon as possible
            </h2>
            <p className="text-sec">All fields are required</p>
          </div>
        </Slide>
        <div className="row">
          <div className="col-lg-8 col-12">
            <form
              style={{
                pointerEvents: loader ? "none" : "auto",
                cursor: loader ? "progress" : "auto",
              }}
              className="w-100"
              onSubmit={sendContactForm}
            >
              <div className="row m-0">
                <div className="col-12 main-input d-flex my-1 justify-content-start align-items-center">
                  <Slide bottom>
                    <div className="profile-labels mb-auto">
                      <label htmlFor="" className="text-secondary">
                        First Name
                      </label>
                    </div>
                    <div className="profile-inputs-wrapper">
                      <CustomInput
                        onBlur={handlePersonalForm}
                        className="blue-input"
                        name="first_name"
                        blueborder={"true"}
                        placeholder="First Name"
                        onChange={handlePersonalForm}
                        value={data.first_name}
                      />
                      {errors?.first_name?.invalid && (
                        <p className="text-danger">{errors?.first_name?.msg}</p>
                      )}
                    </div>
                  </Slide>
                </div>
                <div className="col-12 main-input d-flex my-1 justify-content-start align-items-center">
                  <Slide bottom>
                    <div className="profile-labels  mb-auto">
                      <label htmlFor="" className="text-secondary">
                        Last Name
                      </label>
                    </div>
                    <div className="profile-inputs-wrapper">
                      <CustomInput
                        onBlur={handlePersonalForm}
                        className="blue-input"
                        name="last_name"
                        blueborder={"true"}
                        placeholder="Last Name"
                        onChange={handlePersonalForm}
                        value={data.last_name}
                      />
                      {errors?.last_name?.invalid && (
                        <p className="text-danger">{errors?.last_name?.msg}</p>
                      )}
                    </div>
                  </Slide>
                </div>
                <div className="col-12 main-input d-flex my-1 justify-content-start align-items-center">
                  <Slide bottom>
                    <div className="profile-labels mb-auto">
                      <label htmlFor="" className="text-secondary">
                        Email
                      </label>
                    </div>
                    <div className="profile-inputs-wrapper">
                      <CustomInput
                        onBlur={handlePersonalForm}
                        className="blue-input"
                        type="email"
                        name="email"
                        blueborder={"true"}
                        placeholder="Enter email"
                        onChange={handlePersonalForm}
                        value={data.email}
                      />
                      {errors?.email?.invalid && (
                        <p className="text-danger">{errors?.email?.msg}</p>
                      )}
                    </div>
                  </Slide>
                </div>
                <div className="col-12 main-input d-flex my-1 justify-content-start align-items-center">
                  <Slide bottom>
                    <div className="profile-labels mb-auto">
                      <label htmlFor="" className="text-secondary">
                        Subject
                      </label>
                    </div>
                    <div className="profile-inputs-wrapper">
                      <CustomInput
                        onBlur={handlePersonalForm}
                        className="blue-input"
                        name="subject"
                        blueborder={"true"}
                        placeholder="Enter subject"
                        type="text"
                        onChange={handlePersonalForm}
                        value={data.subject}
                      />
                      {errors?.subject?.invalid && (
                        <p className="text-danger">{errors?.subject?.msg}</p>
                      )}
                    </div>
                  </Slide>
                </div>
                <div className="col-12 main-input d-flex my-1 justify-content-start align-items-center">
                  <Slide bottom>
                    <div className="profile-labels mb-auto">
                      <label htmlFor="" className="text-secondary">
                        Message
                      </label>
                    </div>
                  </Slide>
                  <div className="profile-inputs-wrapper">
                    <CustomInput
                      onBlur={handlePersonalForm}
                      className="blue-input"
                      component={"textarea"}
                      name="message"
                      blueborder={"true"}
                      placeholder="Your message"
                      rows={7}
                      onChange={handlePersonalForm}
                      value={data.message}
                    />
                    {errors?.message?.invalid && (
                      <p className="text-danger">{errors?.message?.msg}</p>
                    )}
                    <Slide bottom>
                      <div className="d-flex">
                        <div className="ml-auto text-secondary">
                          {data.message?.length || 0}/500
                        </div>
                      </div>
                    </Slide>
                    <div className="d-flex mt-2 terms-text">
                      <Slide bottom>
                        <div className="text-secondary user-select-none d-flex justify-content-start align-items-start">
                          <input
                            onChange={handlePersonalForm}
                            checked={data.terms}
                            className="mt-2 cursor-pointer"
                            type="checkbox"
                            name="terms"
                            id="terms"
                          />
                          <label htmlFor="terms" className="px-3 m-0">
                            {" "}
                            By clicking the "Submit" button, you are agreeing to
                            Cyan's{" "}
                            <span className="text-sec cursor-pointer">
                              Terms of Use{" "}
                            </span>{" "}
                            and
                            <span className="text-sec cursor-pointer">
                              {" "}
                              Privacy Policy.
                            </span>
                          </label>
                        </div>
                      </Slide>
                    </div>
                    <Slide bottom>
                      <div className="w-100 mt-4 pt-2">
                        <button type="submit" className="dark-btn w-auto px-3">
                          Send message
                        </button>
                      </div>
                    </Slide>
                  </div>
                </div>

                <div className="col-12 main-input d-flex mt-4 justify-content-start align-items-center">
                  <div className="profile-labels mb-auto mt-3 d-sm-block d-none">
                    <label htmlFor="" className="text-secondary"></label>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="col-lg-4 col-12 h-100 py-4 my-md-5 d-flex flex-column justify-content-center align-items-center">
            <div className="contact-detail-box border overflow-hidden px-3 py-2">
              <Slide bottom>
                <div className="row m-0">
                  <div className="col-12 p-0 mb-4 mt-2">
                    <h6 className="text-secondary">
                      Alternative contact methods
                    </h6>
                  </div>
                  <div className="col-12 d-flex justify-content-start align-items-start mb-3 p-0">
                    <span>
                      <img src={locationIcon} alt="" />
                    </span>
                    <p className="text-pr px-2">Athens, Greece</p>
                  </div>
                  <div className="col-6 d-flex our-detail-pra justify-content-start align-items-start mb-3 p-0">
                    <span>
                      <img src={mailIcon} alt="" />
                    </span>
                    <p className="text-pr px-2">For Marketing</p>
                  </div>
                  <div className="col-6 d-flex our-detail-pra justify-content-start align-items-start mb-3 p-0">
                    {/* <span><img src={mailIcon} alt="" /></span> */}
                    <p className="text-pr px-2">marcom@thecyan.co</p>
                  </div>
                  <div className="col-6 d-flex our-detail-pra justify-content-start align-items-start mb-3 p-0">
                    <span>
                      <img src={mailIcon} alt="" />
                    </span>
                    <p className="text-pr px-2">For Business</p>
                  </div>
                  <div className="col-6 d-flex our-detail-pra justify-content-start align-items-start mb-3 p-0">
                    <p className="text-pr px-2">team.greece@thecyan.co</p>
                  </div>
                </div>
              </Slide>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
